import React, { useContext, useEffect, useReducer, useState } from "react";

import {
    
    BsFillPersonFill
   
  } from "react-icons/bs";
import Nav from "react-bootstrap/Nav";


const LogSign = () => {
  return (
    <>
      <div className="login-signin-block d-flex align-items-center justify-content-center w500 ">
        <p>
          <BsFillPersonFill />{" "}
        </p>
        <Nav.Link href='#'>Sign Up</Nav.Link>
        &nbsp;/&nbsp;
        <Nav.Link href='#'>Log In</Nav.Link>
      </div>
    </>
  );
};

export default LogSign;
